import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=875522bc&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=875522bc&prod&scoped=true&lang=css&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=875522bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875522bc",
  null
  
)

export default component.exports